export default __webpack_public_path__ + "static/B0229-987db1f55fb637813c5c40e72d5e09ef.png";